export default "__VITE_ASSET__D03BV6LQ__"